<template>
    <div class="mSeacher">
        <div class="search">
            <form action="/">
                <van-search v-model="param.key" placeholder="请输入搜索关键词" @search="handelQuery" show-action
                            @cancel="onCancel"></van-search>
            </form>
        </div>
        <div class="filter_box">
            <div class="total">共{{page.rowCount}}个相关活动</div>
            <div class="filter_div">
                <van-dropdown-menu>
                    <van-dropdown-item title="全部筛选" ref="screen">
                        <div class="all_filter_box">
                            <div class="select_box">
                                <p class="title_text">发布时间</p>
                                <div class="select_type select_type1 select_type3">
                                    <div v-for="(item, index) in fbsjList" :key="index"
                                         @click="setTime(item)"
                                         :class="{'active': param.timetype === item.code}">{{item.name}}
                                    </div>
                                </div>
                                <p class="title_text">活动城市</p>
                                <div class="select_type select_type1">
                                    <div v-for="(item, index) in cityList" :key="index"
                                        @click="setCity(item)"
                                         :class="{'active': param.city === item.value}">{{item.name}}
                                    </div>
                                </div>
                                <p class="title_text">活动类型</p>
                                <div class="select_type select_type1">
                                    <div v-for="(item, index) in typeList" :key="index"
                                         @click="setType(item)"
                                         :class="{'active': param.feetype === item.code}">{{item.name}}
                                    </div>
                                </div>
                                <p class="title_text">活动状态</p>
                                <div class="select_type select_type1">
                                    <div v-for="(item, index) in statusList" :key="index"
                                         @click="setStatus(item)"
                                         :class="{'active': param.status === item.code}">{{item.name}}
                                    </div>
                                </div>
                            </div>
                            <div class="btn_box">
                                <van-button @click="resetBtn" type="default">重置</van-button>
                                <van-button @click="sureBtn" type="info">确定</van-button>
                            </div>
                        </div>
                    </van-dropdown-item>
                </van-dropdown-menu>
            </div>
        </div>
    </div>
</template>

<script>
  import {apply} from 'api/enumCode.js'

  export default {
    name: 'mSeacher',
    props: ['param', 'page'],
    data() {
      return {
        isShow: false,
        fbsjList: apply.fbsj,
        cityList: apply.city,
        typeList: apply.type,
        statusList: apply.status
      }
    },
    methods: {
      handelQuery(obj) {
        this.param.key = obj;
        this.$emit('getList')
      },
      queryData() {
        this.$refs.screen.toggle()
        this.$emit('getList')
      },
      onCancel() {
        this.$router.push({name: 'ApplyIndex'});
      },
      setTime(obj) {
        this.param.timetype = obj.code
      },
      setCity(obj) {
        this.param.city = obj.value
      },
      setType(obj) {
        this.param.feetype = obj.code
      },
      setStatus(obj) {
        this.param.status = obj.code
      },
      resetBtn() {
        this.param.timetype = ''
        this.param.city = ''
        this.param.feetype = ''
        this.param.status = ''
      },
      sureBtn() {
        this.queryData()
      },
    },
    filters: {},
    computed: {},
    components: {}
  }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    @import "~common/scss/variable";

    .mSeacher {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        background: $c-white;
        z-index: 1;
        .search {
            padding: 0.15rem 0.32rem;
            box-sizing: border-box;
            height: 0.88rem;
            font-size: 0.28rem;
            border-bottom: 0.01rem solid $line;
            .van-search {
                padding: 0;
                height: 0.58rem;
                line-height: 0.58rem;
                .van-search__content {
                    padding-left: 0;
                    border-radius: 0.29rem;
                    overflow: hidden;
                }
                .van-search__action {
                    padding-left: 0.4rem;
                    padding-right: 0;
                    color: $c-blue;
                }
                .van-cell {
                    background: #F5F5F5;
                    padding: 0.05rem 0.16rem 0.05rem 0;
                }
                .van-field__left-icon {
                    margin-left: 0.24rem;
                }
            }
        }
        .filter_box {
            overflow: hidden;
            background-color: #FFF;
            height: 0.94rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 0.32rem;
            font-size: 0.26rem;
            .total, .name {
                color: $c-grey;
                line-height: 0.4rem;
            }
            .filter_div {
                width: 4rem;
                .van-dropdown-menu__bar {
                    box-shadow: none;
                }
                .van-dropdown-menu__title {
                    color: #999;
                    font-size: 0.26rem;
                }
                .van-dropdown-menu__title--active {
                    color: #1989fa;
                }
                .btn_box {
                    background-color: pink;
                    .van-button {
                        width: 50%;
                    }
                }
                .industry_filter_box, .all_filter_box {
                    .select_box {
                        padding: 0 0.32rem;
                        .title_text {
                            line-height: 0.8rem;
                            font-size: 0.28rem;
                            color: #666;
                        }
                        .select_type {
                            display: flex;
                            flex-wrap: wrap;
                            .active {
                                background: rgba(46, 127, 255, 0.1);
                                color: #2E7FFF;
                            }
                        }
                        .select_type1 {
                            padding-bottom: 0.12rem;
                            & > div {
                                border-radius: 0.04rem;
                                width: 1.58rem;
                                height: 0.52rem;
                                line-height: 0.52rem;
                                font-size: 0.24rem;
                                color: #666;
                                background-color: #F6F6F6;
                                text-align: center;
                                margin-top: 0.12rem;
                                margin-right: 0.18rem;
                            }
                            & > div:nth-of-type(1), & > div:nth-of-type(2), & > div:nth-of-type(3), & > div:nth-of-type(4) {
                                margin-top: 0.08rem;
                            }
                            & > div:nth-of-type(4n) {
                                margin-right: 0
                            }
                        }
                        .select_type2 {
                            padding-bottom: 0.32rem;
                            & > div {
                                border-radius: 0.04rem;
                                width: 2.16rem;
                                height: 0.52rem;
                                line-height: 0.52rem;
                                font-size: 0.24rem;
                                color: #666;
                                background-color: #F6F6F6;
                                text-align: center;
                                margin-top: 0.12rem;
                                margin-right: 0.18rem;
                            }
                            & > div:nth-of-type(1), & > div:nth-of-type(2), & > div:nth-of-type(3) {
                                margin-top: 0.08rem;
                            }
                            & > div:nth-of-type(3n) {
                                margin-right: 0
                            }
                        }
                        .select_type3 {
                            padding-bottom: 0.32rem;
                        }
                    }
                }
                .all_filter_box {
                    .select_box {
                        height: 6.32rem;
                        overflow-y: scroll;
                    }
                }
            }
        }

        .van-dropdown-menu__item {
            justify-content: flex-end;
        }
        .van-dropdown-item__content {
            max-height: 90%;
        }
    }
</style>